export const MODELS_TABLE_CONTROLLER = 'models';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ModelsTable/ModelsTableConstants.js